import { useToasts } from '../hooks';

export function Toasts() {
  const toasts = useToasts();
  return (
    <div className="toasts" role="status" aria-live="polite">
      {toasts.map((t) => (
        <div className="toast" key={t.id}>
          <div>{t.title}</div>
          {t.sub && <small>{t.sub}</small>}
        </div>
      ))}
    </div>
  );
}
